import { QueryParams } from './common';

export enum DishStatus {
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
}

export interface Category {
  id: string;
  name: string;
  displayOrder: number;
  printDepartment?: string[] | null;
  restaurantId: string;
  dishes?: Dish[];
  createdAt?: string;
  updatedAt?: string;
}

export interface DayAvailability {
  enabled: boolean;
  from?: string;
  to?: string;
}

export interface AvailabilitySchedule {
  saturday?: DayAvailability;
  sunday?: DayAvailability;
  monday?: DayAvailability;
  tuesday?: DayAvailability;
  wednesday?: DayAvailability;
  thursday?: DayAvailability;
  friday?: DayAvailability;
}

export interface DishAddOn {
  id: string;
  dishId: string;
  name: string;
  price: number;
  freeQuantity: number;
  maxQuantity?: number;
  isActive: boolean;
  sortOrder: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface Dish {
  id: string;
  name: string;
  price: number;
  description?: string;
  image?: string;
  status: DishStatus;
  categoryId?: string | null;
  restaurantId: string;
  displayOrder?: number;
  preparationTime: number;
  availabilitySchedule?: AvailabilitySchedule;
  unavailableUntil?: string;
  unavailableReason?: string;
  isCurrentlyAvailable?: boolean;
  availabilityMessage?: string;
  availableAt?: string;
  addOns?: DishAddOn[];
  templateId?: string | null;
  productGroup?: string;
  variantName?: string;
  restaurant?: any; // Avoid circular import with Restaurant
  category?: Category;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateCategoryDto {
  name: string;
  displayOrder?: number;
  printDepartment?: string[] | null;
}

export interface UpdateCategoryDto {
  name?: string;
  displayOrder?: number;
  printDepartment?: string[] | null;
}

export interface CreateDishDto {
  name: string;
  price: number;
  description?: string;
  status?: DishStatus;
  categoryId?: string;
  preparationTime?: number;
  image?: File;
  templateId?: string | null;
  productGroup?: string;
  variantName?: string;
}

export interface UpdateDishDto {
  name?: string;
  price?: number;
  description?: string;
  status?: DishStatus;
  categoryId?: string | null;
  preparationTime?: number;
  image?: File;
  availabilitySchedule?: AvailabilitySchedule | null;
  unavailableUntil?: string | null;
  unavailableReason?: string | null;
  templateId?: string | null;
  productGroup?: string;
  variantName?: string;
}

export interface SetUnavailabilityDto {
  hours: number;
  reason?: string;
}

export interface CreateDishAddOnDto {
  name: string;
  price?: number;
  freeQuantity?: number;
  maxQuantity?: number;
  isActive?: boolean;
}

export interface UpdateDishAddOnDto {
  name?: string;
  price?: number;
  freeQuantity?: number;
  maxQuantity?: number;
  isActive?: boolean;
  sortOrder?: number;
}

export interface BulkUpdateDishAddOnsDto {
  addOns: Array<Partial<DishAddOn> & { id?: string }>;
}

export interface DishQueryParams extends QueryParams {
  categoryId?: string;
  status?: DishStatus;
  minPrice?: number;
  maxPrice?: number;
}
